import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { CrudService } from 'src/app/services/crud.service';
import { TranslateService } from '@ngx-translate/core';
import { clearAllSavedDateRanges } from 'src/app/shared/components/date-range-filter/date-range-memory';
import { sessionEmail } from 'src/app/core/session-email';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  BASE_URL: string;
  USER_MANAGEMENT_URL: string;
  QUOTE_TEMPLATE_URL:string;


  constructor(
    private http: HttpClient,
    private gService: CrudService,
    private translate: TranslateService
  ) {
    this.BASE_URL = environment.API_URL;
    this.USER_MANAGEMENT_URL = environment.USER_MANAGEMENT_URL;
    this.QUOTE_TEMPLATE_URL= environment.QUOTE_MANAGEMENT_URL;

  }


  getCustomerCards(data: any): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchant/getcustomercard`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  setDefaultCard(data: any): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchant/setdefaultcard`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  getTransactions(data: any): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchant/gettransactions`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  getInvoices(data: any): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchant/getinvoice`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  addCustmerCard(data: any): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchant/addcreditcard`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  deleteCustmerCard(data: any): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/merchant/deletecustomercards/` + data.cardId, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  getMerchantProfile(): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchant/merchantprofile`, {}).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  getAvailablePlans(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/plan/list`).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  getAvailableAddons(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/addon/list`).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
  deleteMerchant(data: any): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchant/merchantprofile`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  async logout(isLogout = true): Promise<void> {
    const payload = {
      id: localStorage.getItem('userId'),
      email: sessionEmail(), // Card #381: same key the session was created under
      merchant_id: localStorage.getItem('merchant_id'),
      device_id: localStorage.getItem('deviceLoginId')
    };
    await this._removeSession(payload);
    localStorage.removeItem('merchant_id');
    localStorage.removeItem('deviceLoginId');
    if (isLogout) {
      localStorage.removeItem('reminderList');
      localStorage.removeItem('profile_pic');
      localStorage.removeItem('user_merchants');
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('fname');
      localStorage.removeItem('lname');
      localStorage.removeItem('create-session');
      localStorage.removeItem('redirect-merchant');
      localStorage.removeItem('email');
      localStorage.removeItem('loginUserValue');
      // Card #269: remembered report date ranges never outlive the session.
      clearAllSavedDateRanges();
      localStorage.removeItem('osmos_access_level');
      localStorage.removeItem('permission');
      localStorage.removeItem('role');
      localStorage.removeItem('country_list');
      localStorage.removeItem('accessId');
      // Quote-listing saved sort preferences
      localStorage.removeItem('quoteListingSortField');
      localStorage.removeItem('quoteListingSortOrder');
      localStorage.removeItem('quoteListingCustomSort');
      localStorage.removeItem('quoteListingSortColumn');
      this.translate.use('en');
    }
  }

  _removeSession(body) {
    return this.gService.postUserManagement(`merchantuser/removeusersession`, body)
      .toPromise()
      .catch(error => { console.log(error, "error"); });
  }

   getWidgetsModule(): Observable<any> {
      return this.gService.getUserManagement(`widgets/get-widgets-module`);
   }

  getWidgetsModuleBySlug(slug: string): Observable<any> {
    return this.gService.getUserManagement(`widgets/get-widgets-module/${slug}`);
 }

   getWidgets(): Observable<any> {
      return this.gService.getUserManagement(`widgets/get-widgets`);
   }

   addMerchantWidget(form: any) {
    return this.gService.postUserManagement('widgets/add-merhcant-widgets', form);
  }

  
  deleteMerchantWidget(id) {
    return this.gService.deleteUserManagement(`widgets/delete-merhcant-widgets/${id}`);
  }

  updateOrderMerchantWidget(data) {
    // Backend answers this endpoint with a plain-text body ("Widget order updated
    // successfully"), so request text — HttpClient's default JSON parsing turns the
    // 200 response into an "Http failure during parsing" HttpErrorResponse.
    return this.http.put(`${this.USER_MANAGEMENT_URL}/widgets/update-order-merchant-widgets`, data, { responseType: 'text' }).pipe(
      map((response: any) => response ?? {}),
      catchError((err: any) => {
        console.error('updateOrderMerchantWidget failed:', err);
        return of(null);
      })
    );
  }
  get_Lead_Form_list(data: any): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/lead-template/templateList`, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => {
        return err;
      })
    );
  }

  get_Quote_Stages(data: any=''): Observable<any> {
    return this.http.get(`${this.QUOTE_TEMPLATE_URL}/quoteStagesList`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => {
        return err;
      })
    );
  }

  integrations(data: any=''): Observable<any> {
    return this.http.post(`${this.QUOTE_TEMPLATE_URL}/integrations/create`,data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => {
        return err;
      })
    );
  }

  getBusinessProfile(data: any, merchantId): Observable<any> {
    return this.http.post(`${this.BASE_URL}/merchantinfo/${merchantId}`, data).pipe(
      tap(
        data => data,
        error => error
      )
    );
  }
}
